
import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    // Schema.org JSON-LD pour la page d'accueil
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "HealthAndBeautyBusiness",
      "name": "Zen Wellness Guadeloupe",
      "description": "Centre de bien-être et massages thérapeutiques en Guadeloupe offrant des services de relaxation, massages thérapeutiques, réflexologie et aromathérapie",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Centre-ville",
        "addressLocality": "Pointe-à-Pitre",
        "addressRegion": "Guadeloupe",
        "postalCode": "97110",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "16.2415",
        "longitude": "-61.5331"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "19:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "09:00",
          "closes": "17:00"
        }
      ],
      "priceRange": "€€",
      "telephone": "+590-XXX-XXX-XXX",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Services de bien-être",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Massage Relaxant",
              "description": "Massage complet pour la détente et la relaxation"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Massage Thérapeutique",
              "description": "Massage ciblé pour soulager les tensions musculaires"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Réflexologie",
              "description": "Thérapie par stimulation des points réflexes des pieds"
            }
          }
        ]
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "127"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <main>
      <HeroSection />
      <ServicesSection />
      <BenefitsSection />
      <TestimonialsSection />
      <PricingSection />
      <FAQSection />
      <ContactSection />
    </main>
  );
}
